import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchProducts = async (includeArchived = false) => {
  const res = await axios.get(`${API}/products`, {
    params: includeArchived ? { include_archived: true } : {},
  });
  return res.data;
};

export const createProduct = async (data) => {
  const res = await axios.post(`${API}/products`, data);
  return res.data;
};

export const updateProduct = async (id, data) => {
  const res = await axios.put(`${API}/products/${id}`, data);
  return res.data;
};

export const deleteProduct = async (id) => {
  const res = await axios.delete(`${API}/products/${id}`);
  return res.data;
};

export const fetchGames = async () => {
  const res = await axios.get(`${API}/games`);
  return res.data;
};

export const fetchSchool = async () => {
  const res = await axios.get(`${API}/school`);
  return res.data;
};

export const fetchTv = async () => {
  const res = await axios.get(`${API}/tv`);
  return res.data;
};
